import { combineReducers } from 'redux';

//
//
//    THIS IS A DEAD REDUCER
//
//    All the new stuff is in frontend/state/reducers/simbot/optimize/enhancements.js
//
//    This just returns empty/null values that shouldn't affect anything new (but still maintain compatibility)
//
//

export default combineReducers({
  gem: () => [],
  cloakEnchant: () => [],
  ringEnchant: () => [],
  neckEnchant: () => [],
  weaponEnchant: () => [],
  weaponOffhandEnchant: () => [],
  replaceExisting: () => false,
  useMainStatGem: () => false,
});

const baseSelector = state => state.simbot.optimize.gemEnchant;
const gemSelector = state => baseSelector(state).gem;
const cloakEnchantSelector = state => baseSelector(state).cloakEnchant;
const ringEnchantSelector = state => baseSelector(state).ringEnchant;
const neckEnchantSelector = state => baseSelector(state).neckEnchant;
const weaponEnchantSelector = state => baseSelector(state).weaponEnchant;
const weaponOffhandEnchantSelector = state => baseSelector(state).weaponOffhandEnchant;
const replaceExistingSelector = state => baseSelector(state).replaceExisting;
const useMainStatGemSelector = state => baseSelector(state).useMainStatGem;

export const selectors = {
  gem: gemSelector,
  cloakEnchant: cloakEnchantSelector,
  ringEnchant: ringEnchantSelector,
  neckEnchant: neckEnchantSelector,
  weaponEnchant: weaponEnchantSelector,
  weaponOffhandEnchant: weaponOffhandEnchantSelector,
  replaceExisting: replaceExistingSelector,
  useMainStatGem: useMainStatGemSelector,
};
